<template>
  <a
    :class="{
      pl_block: horizontal,
      tl_block: vertical,
      plt_block_left: squareLeft,
      plt_block_right: squareRight,
      act: selectedCount > 0,
      tl_none:
        product.is_stopped || category.work_time.is_working_now === false,
    }"
    @mousedown="draggble = false"
    @mousemove="draggble = true"
    @mouseup="addToBasket($event)"
  >
    <div
      :class="{
        pl_img: horizontal,
        plt_img: squareLeft || squareRight,
        tl_img: vertical,
      }"
    >
      <div
        v-lazyloadImage
        class="placeholder"
        :style="{ paddingTop: placeholderPadding }"
      >
        <div v-if="product.images.length > 1" class="product-image-multiple">
        </div>
        <div
          class="pl_sale_num"
          v-for="(label, index) in discountLabels"
          :key="`${label}_${index}`"
          :class="{ 'rtl-pl_sale_num': isRtl }"
          :style="{ background: label.color, color: label.textColor }"
        >
          {{
            `–${Math.round(100 - (product.price / product.old_price) * 100)}%`
          }}
        </div>
        <img
          @load="setHeight"
          v-if="product.images.length"
          style="object-fit: cover"
          alt=""
          class="placeholded-image"
          :data-url="getImageUrl(product, IMAGE_TYPE_SPLASH)"
          :data-srcset="
            getImageUrl(product, IMAGE_TYPE_SPLASH) +
            ' 1x, ' +
            getImageUrl(product, IMAGE_TYPE_SPLASH_2X) +
            ' 2x'
          "
        />
        <div class="tl_graphics">
          <template v-if="$store.getters.ecommerceBasketAct === 2">
            <div class="pl_basket_ico" v-if="selectedCount > 0">
              <img
                :src="require('@/assets/img/ecommerce/product_basket_act.svg')"
              />
            </div>
            <div class="pl_basket_ico" v-else>
              <img
                :src="require('@/assets/img/ecommerce/product_basket.svg')"
              />
            </div>
          </template>
          <template v-if="$store.getters.ecommerceBasketAct === 1">
            <div
              class="pl_basket act"
              :class="{
                'rtl-pl_basket': isRtl,
                'ios-font': $store.getters.checkIos,
              }"
              v-if="selectedCount > 0"
            >
              {{ text("in_basket") }}
            </div>
            <div
              class="pl_basket"
              :class="{
                'rtl-pl_basket': isRtl,
                'ios-font': $store.getters.checkIos,
              }"
              v-else
            >
              {{ text("add_to_basket") }}
            </div>
          </template>
        </div>
      </div>
      <div :class="setPlOrientation" v-if="popularPreview">
        <div class="pl_char">
          <div
            class="pl_action_inner"
            :class="{ 'ios-font': $store.getters.checkIos }"
            v-for="(label, index) in defaultLabels"
            :key="`pl_char-${index}`"
            :style="{ background: label.color, color: label.textColor }"
          >
            {{ label.name }}
          </div>
        </div>
      </div>
    </div>

    <div :class="{ plt_content: this.squareLeft || this.squareRight }">
      <div :class="{ tl_head: popularPreview }">
        <div class="tl_name" :class="{ 'weight-500': popularPreview }">
          {{ product.name }}
        </div>

        <div style="display: flex" v-if="popularPreview">
          <template v-if="product.show_price">
            <div
              class="tl_head_price bl_discounted_price"
              v-if="product.old_price && oldPrice"
              :class="{
                rtl_head_price: isRtl,
                'ios-font': $store.getters.checkIos,
              }"
            >
              {{ oldPrice }}
            </div>
            <div
              class="tl_head_price"
              :class="{
                rtl_head_price: isRtl,
                'ios-font': $store.getters.checkIos,
              }"
            >
              {{ price }}
            </div>
          </template>
        </div>
      </div>

      <div class="pl_char_price_block" v-if="!popularPreview">
        <template v-if="product.show_price">
          <div
            class="pl_char_price"
            :class="{ 'ios-font': $store.getters.checkIos }"
          >
            <span v-if="product.old_price && oldPrice">{{ oldPrice }}</span>
            {{ price }}
            <div v-if="product.showcase_qty" class="pl_char_price_qty">
              {{ product.showcase_qty }}
            </div>
          </div>
        </template>
      </div>
      <div class="pl_char" v-if="!popularPreview">
        <div
          class="pl_action_inner"
          :class="{ 'ios-font': $store.getters.checkIos }"
          v-for="(label, index) in defaultLabels"
          :key="`pl_char-${index}`"
          :style="{ background: label.color, color: label.textColor }"
        >
          {{ label.name }}
        </div>
      </div>

      <div
        :class="{ pl_content: horizontal, plt_content: vertical }"
        style="margin-top: 0"
      >
        <div
          v-if="
            !popularPreview &&
            $store.getters.ecommerceBasketAct === 0 &&
            this.squareLeft &&
            this.squareRight
          "
          class="pl_btn"
        >
          <a @click="addToBasket">{{ text("add_to_basket") }}</a>
        </div>
      </div>
    </div>

    <div
      v-if="
        !popularPreview &&
        $store.getters.ecommerceBasketAct === 0 &&
        !this.squareLeft &&
        !this.squareRight
      "
      class="pl_btn"
    >
      <a @click="addToBasket">{{ text("add_to_basket") }}</a>
    </div>
  </a>
</template>

<script>
import {
  SET_CURRENT_PRODUCT,
  SET_MODAL,
  SET_SELECTED_PRODUCTS,
} from "@/store/mutations.type";
import LazyLoadDirective from "../../../directives/LazyLoadDirective";

const marked = require("marked");
const renderer = {
  code(code, infostring, escaped) {
    return "<p>" + code + "</p>";
  },
};
marked.use({ renderer });

export default {
  name: "ProductListItem",
  props: {
    product: Object,
    popularPreview: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    lazyloadImage: LazyLoadDirective,
  },
  data() {
    return {
      draggble: false,
      IMAGE_TYPE_ORIGINAL: 0,
      IMAGE_TYPE_SPLASH: 1,
      IMAGE_TYPE_SPLASH_2X: 2,
      IMAGE_TYPE_LARGE: 3,

      LABEL_TYPE_DEFAULT: 0,
      LABEL_TYPE_DISCOUNT: 10,

      css_direction: "ltr",
    };
  },
  methods: {
    addToBasket() {
      if (!this.draggble) {
        if (
          this.product.is_stopped ||
          this.category.work_time.is_working_now === false
        ) {
          return;
        }
        this.$store.commit(SET_CURRENT_PRODUCT, this.product);
        this.$store.commit(SET_MODAL, { modal: "product", status: true });
      }
    },

    getImageUrl(product, type) {
      let params = "";

      if (type === this.IMAGE_TYPE_ORIGINAL) {
        return product.images[0].original + params;
      }
      if (type === this.IMAGE_TYPE_SPLASH) {
        return product.images[0].splash + params;
      }
      if (type === this.IMAGE_TYPE_SPLASH_2X) {
        return product.images[0].splash_2x + params;
      }
      if (type === this.IMAGE_TYPE_LARGE) {
        return product.images[0].large + params;
      }
    },

    isLong(description) {
      if (this.squareLeft || this.squareRight) {
        return true;
      }
      return description.length >= 110;
    },

    renderDescription(description) {
      return marked(this.$options.filters.nl2br(description));
    },

    setHeight(event) {
      let image = event.target;

      if (this.horizontal) {
        image.height = image.clientWidth * 0.5625;
      } else if (this.squareLeft || this.squareRight) {
        image.height = image.clientWidth;
      } else if (this.vertical) {
        image.height = 230;
      }
    },
  },
  computed: {
    isRtl() {
      return this.css_direction === "rtl";
    },
    discountLabels() {
      return this.product.old_price
        ? this.product.labels.filter(
            (label) => label.type === this.LABEL_TYPE_DISCOUNT
          )
        : [];
    },
    defaultLabels() {
      return this.product.labels.filter(
        (label) => label.type === this.LABEL_TYPE_DEFAULT
      );
    },
    price() {
      if (
        this.product.is_stopped ||
        this.category.work_time.is_working_now === false
      ) {
        return this.text("product_not_available");
      }
      return this.$options.filters.toCurrency(+this.product.showcase_price || this.product.price);
    },
    oldPrice() {
      if (
        this.product.is_stopped ||
        this.category.work_time.is_working_now === false
      ) {
        return null;
      }
      return this.$options.filters.toCurrency(this.product.old_price);
    },
    setPlOrientation() {
      if (this.priceOnPhoto || this.product.old_price) {
        return "topleft";
      } else if (!this.priceOnPhoto && this.css_direction === "rtl") {
        return "bottomleft";
      } else if (!this.priceOnPhoto) {
        return "bottomright";
      }
    },
    selectedCount() {
      let selectedCount = 0;
      this.$store.getters.selectedProducts.forEach((element) => {
        if (element.id === this.product.id) {
          selectedCount += element.count;
        }
      });
      return selectedCount;
    },

    category() {
      for (let i in this.$store.getters.categories) {
        if (this.$store.getters.categories[i].id === this.product.category_id) {
          return this.$store.getters.categories[i];
        }
      }
      return null;
    },

    horizontal() {
      return (
        this.popularPreview ||
        this.$store.getters.imagesStyle === this.$store.getters.IMAGES_WIDE
      );
    },

    squareLeft() {
      return (
        !this.popularPreview &&
        this.$store.getters.imagesStyle ===
          this.$store.getters.IMAGES_SQUARE_LEFT
      );
    },

    squareRight() {
      return (
        !this.popularPreview &&
        this.$store.getters.imagesStyle ===
          this.$store.getters.IMAGES_SQUARE_RIGHT
      );
    },

    vertical() {
      return (
        !this.popularPreview &&
        this.$store.getters.imagesStyle === this.$store.getters.IMAGES_VERTICAL
      );
    },

    placeholderPadding() {
      if (this.horizontal) {
        return "56.25%";
      } else if (this.squareLeft || this.squareRight) {
        return "100%";
      } else if (this.vertical) {
        return "230px";
      }

      return null;
    },
  },
  mounted() {
    this.css_direction = this.$store.getters.guardCssDirection;
  },
};
</script>

<style scoped>
.bottomright {
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.bottomleft {
  position: absolute;
  left: 10px;
  bottom: 10px;
}

.topleft {
  position: absolute;
  left: 10px;
  top: 10px;
}

.topleft .pl_char {
  -webkit-box-pack: start;
  justify-content: flex-start;
}

.plt_content {
  display: grid;
  width: 100%;
}

div.placeholder {
  width: 100%;
  height: 0;
  background: #f7f7f7;
  position: relative;
  border-radius: 16px;
}

img.placeholded-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.cross {
  padding: 0 3px;
  font-size: 11px;
  font-weight: bold;
}

.pl_char {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 6px;
  grid-auto-flow: row dense;
}

.ltr-on-rtl .pl_char {
  direction: ltr;
}

.pl_char_price_block {
  display: block;
}

.pl_char_price {
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1b;
  line-height: 100%;
}

.pl_char_price .pl_char_price_qty {
  display: inline-flex;
  font-size: 12px;
  color: #999999;
}

.pl_char_price span {
  display: block;
  font-size: 10px;
  line-height: 100%;
  color: #1a1a1b;
  opacity: 0.5;
  padding-bottom: 4px;
  text-decoration: line-through;
}

.pl_char_price span {
  display: block;
  font-size: 10px;
  line-height: 100%;
  color: #1a1a1b;
  opacity: 0.5;
  padding-bottom: 4px;
  text-decoration: line-through;
}

.rtl .pl_char_price {
  text-align: right;
}

.ltr-on-rtl .pl_char_price {
  text-align: left;
}

.pl_action {
  display: flex;
  flex-direction: column;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}

.pl_action .pl_action_row {
  display: flex;
  flex-direction: row;
  /*margin-bottom: 2px;*/
}

.pl_action_inner {
  padding: 0 3px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 2px;
  font-size: 9px;
  font-weight: bold;
}

.pl_basket.act {
  color: #fff;
  background: #0084ff;
}

.pl_btn {
  align-items: flex-end;
  bottom: 0;
  display: flex;
  margin-top: 11px;
  -webkit-align-items: flex-end;
}

.pl_btn a {
  display: flex;
  padding-left: 30px;
  padding-right: 30px;
  color: #0084ff;
  border: 1px solid #0084ff;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  color: #0084ff;
  height: 35px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.rtl .pl_action {
  -webkit-order: 1;
  -ms-order: 1;
  order: 1;
}

.rtl .tl_name {
  text-align: right;
}

.ltr-on-rtl .tl_name {
  text-align: left;
}

.rtl .pl_btn {
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}

.ltr-on-rtl .pl_btn {
  flex-direction: row-reverse;
}

.bl_discounted_price {
  text-decoration: line-through;
  color: #a3a3a3;
  font-weight: normal;
}

.tl_head {
  margin-top: 9px;
  display: flex;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.tl_head .tl_name {
  margin-top: 0;
}

.tl_head_price + .tl_head_price {
  margin-left: 6px;
}

.rtl_head_price + .rtl_head_price {
  margin-right: 6px;
  margin-left: 0;
}

.rtl .tl_head_price {
  margin-left: 6px;
}

.weight-500 {
  font-weight: 500;
}

.product-image-multiple {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 26px;
  height: 26px;
  z-index: 10;
  background-size: cover;
  background-image: url("../../../assets/img/ecommerce/multiple_photo.png")
}

</style>
